import React from "react";
import { motion } from "framer-motion";

const SyllabusSection = () => {
  const syllabusItems = [
    {
      title: "Introduction to Educational Workflows",
      progress: 75,
      color: "bg-purple-500",
    },
    {
      title: "AI Content Generation & Automation",
      progress: 60,
      color: "bg-blue-500",
    },
    {
      title: "Student Progress Tracking System",
      progress: 90,
      color: "bg-green-500",
    },
    {
      title: "Visual Content Management Tools",
      progress: 45,
      color: "bg-orange-500",
    },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h2 className="text-lg font-bold text-gray-900 mb-6">
        Workflow Modules / Progress
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {syllabusItems.map((item, index) => (
          <div key={index} className="group">
            <div className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors duration-200 h-32 flex flex-col justify-between">
              <h3 className="font-medium text-gray-900 text-sm leading-relaxed line-clamp-3">
                {item.title}
              </h3>

              <div className="mt-auto">
                <div className="mb-3">
                  <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <motion.div
                      className={`${item.color} h-2 rounded-full`}
                      initial={{ width: 0 }}
                      animate={{ width: `${item.progress}%` }}
                      transition={{
                        duration: 1,
                        ease: "easeOut",
                        delay: index * 0.2,
                      }}
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-xs">
                    {item.progress}% Complete
                  </span>
                  <button className="text-blue-600 hover:text-blue-700 text-sm font-medium transition-colors duration-200">
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SyllabusSection;
